<template>
    <div class="bgcode">

        <div class="content">
            <vue-qr :text="ownerCode" :size="sizeCode"></vue-qr>
            <div>
                <van-button type="primary" size="mini" class="btnInfo" @click="goInfo">
                    信息维护
                    <van-icon name="arrow" class="arrowicon"/>
                </van-button>
                <p class="line">-----------------------------</p>
                <p class="tip">
                    请将您的车主码出示给门店导购员扫码购车，享受原厂部件质保。
                </p>
            </div>
        </div>

        <div>
            <!-- <van-button plain type="primary" class="btnPhione" @click="goPhone">切换手机号</van-button> -->
        </div>
    </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
    components: { VueQr },
    data() {
        return {
            ownerCode: '',
            sizeCode:200,
        }
    },
    created () {
        let id = this.$store.state.ownerInfo.id;
        this.ownerCode = JSON.stringify({ownerCode:id})
    },
    mounted () {
        console.log(window.innerWidth,document.body.clientWidth)
        if(document.body.clientWidth < 350){
            this.sizeCode = 140
        }
        if(document.body.clientWidth > 400){
            this.sizeCode = 230
        }
    },
    methods: {
        goPhone() {
            this.$router.push({
                path:'/phonelogin',
                params: {
                    urldata:'changePhone',
                }
            })
        },
        goInfo(){
            this.$router.push({
                path:'/ownerinfo'
            })
        }
    },
}
</script>

<style lang="scss" scoped>
// @media (max-width: 400px){
//     .btnInfo {
//         margin-top: 50px;
//     }
//     .line{
//         margin:  20px 0;
//     }
// }
.bgcode {
    background: url('../../assets/owner/Invoiced.png');
    background-size: 100% 100%;
    width: 100%;
    height: 100vh;

    .content {
        position: relative;
        top: 33%;

        .btnInfo {
            background: #FFDCDE;
            border-radius: 13px;
            font-size: 14px;
            font-weight: 400;
            color: #FF232D;
            border: 0;
            padding: 6px 6px 6px 12px;
            margin-top: 1%;
        }
        .arrowicon{
            vertical-align: middle;
        }

        .line {
            color: #E0E0E0;
            margin: 0;
        }

        .tip {
            font-size: 14px;
            font-weight: 400;
            color: #FF232D;
            margin: 0;
            text-align: center;
            width: 60%;
            margin-left: 20%;
        }
    }

    .btnPhione {
        font-size: 18px;
        font-weight: 400;
        color: #FF323A;
        border: 1px solid #FF232D;
        border-radius: 23px;
        background: transparent;
        position: absolute;
        width: 80%;
        left: 10%;
        bottom: 30px;
    }
}
</style>